// extracted by mini-css-extract-plugin
export var carrierIcon = "_wx-0";
export var carrierLogo = "_wx-1";
export var detailsSection = "_wx-2";